export class Token {
  static tokeNameInSotage = "tokenJWT";
  static refreshTokenNameInStorage = "refreshToken";
}



// WEBPACK FOOTER //
// ./src/app/models/token.ts